import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Role } from "../models";

@Injectable()
export class RoleService {

    rolesUrl = environment.dns + 'api/roles/';

    constructor(private http: HttpClient) { }

    getList(): Observable<Role[]> {
        return this.http.get<Role[]>(this.rolesUrl + 'list');
    }

}